import { useTranslation } from "react-i18next";
import { LeafModal } from "../../../common/leaf/LeafModal/LeafModal";
import defaultContent from "../../../content/actionReports";
import "./ActionReportExportConfirmation.scss";

type ActionReportExportConfirmationProps = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  reportDescription: string;
};

export const ActionReportExportConfirmation = ({
  open,
  onCancel,
  onConfirm,
  reportDescription,
}: ActionReportExportConfirmationProps) => {
  const { t } = useTranslation(["actionReports"]);

  return (
    <LeafModal open={open} onCloseCallbackFn={onCancel} id="action-report-export-confirmation">
      <div className="action-report-export-confirmation__content" data-testid="export-confirmation-modal">
        <h2 className="action-report-export-confirmation__title">
          {t("exportConfirmation.title", defaultContent.exportConfirmation.title)}
        </h2>
        <p className="action-report-export-confirmation__description">{reportDescription}</p>
        <div className="action-report-export-confirmation__actions">
          <button
            className="action-report-export-confirmation__button action-report-export-confirmation__button--cancel"
            onClick={onCancel}
            type="button"
            data-testid="export-confirmation-cancel"
          >
            {t("exportConfirmation.cancel", defaultContent.exportConfirmation.cancel)}
          </button>
          <button
            className="action-report-export-confirmation__button action-report-export-confirmation__button--confirm"
            onClick={onConfirm}
            type="button"
            data-testid="export-confirmation-confirm"
          >
            {t("exportConfirmation.export", defaultContent.exportConfirmation.export)}
          </button>
        </div>
      </div>
    </LeafModal>
  );
};
